import { chakra, shouldForwardProp } from "@chakra-ui/react"
import { isValidMotionProp, motion } from "framer-motion"
import { ComponentType } from "react"

const MotionEnabledComponent = (element: string | ComponentType) =>
  chakra(motion(element), {
    //allow motion props and non-Chakra props to be forwarded.
    shouldForwardProp: (prop) => isValidMotionProp(prop) || shouldForwardProp(prop),
  })

export default MotionEnabledComponent
